import { render } from "./BornModal.vue?vue&type=template&id=0731fde7&scoped=true"
import script from "./BornModal.vue?vue&type=script&lang=js"
export * from "./BornModal.vue?vue&type=script&lang=js"

import "./BornModal.vue?vue&type=style&index=0&id=0731fde7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0731fde7"]])

export default __exports__